import VideoAnalyticsDetailPage from './VideoAnalyticsDetailPage';
export default VideoAnalyticsDetailPage;